import { httpRequest } from '@shared/api/httpRequests'
import { minimumLoadingTime } from '@shared/utils/loader'

export function useServerSideDatasource(config, customParams = {}, maxRows = Infinity, emits = null, _, gridState = null) {
  const { url, headers = {}, method = 'POST' } = config || {}

  if (!url) throw new Error('URL is required for server-side datasource')
  if (!gridState) console.warn('[Datagrid] ServerSideDataSource: gridState is null')

  const getRows = async (params) => {
    params.api.hideOverlay()
    if (emits && typeof emits === 'function') emits('request-fired', params)

    const agGrid = {
      startRow: params.request.startRow,
      endRow: Math.min(params.request.endRow, maxRows),
      rowGroupCols: params.request.rowGroupCols || [],
      valueCols: params.request.valueCols || [],
      pivotCols: params.request.pivotCols || [],
      pivotMode: params.request.pivotMode || false,
      groupKeys: params.request.groupKeys || [],
      filterModel: params.request.filterModel || {},
      sortModel: params.request.sortModel || [],
    }

    const request = {
      agGrid,
      queueName: 'NOT_SET',
      ...customParams,
    }

    if (customParams.esPaginationApiType === 'search_after') {
      const gridContext = params.context || params.api.getGridOption('context')
      if (gridContext?.esPaginationApiType !== 'search_after') {
        params.api.setGridOption('context', {
          ...gridContext,
          esPaginationApiType: 'search_after',
        })
      }
      if (gridContext?.reverseSearch) {
        request['reverse'] = gridContext.reverseSearch
      }
      if (gridContext?.searchAfter) {
        request['searchAfter'] = gridContext.searchAfter
      }
    }

    // Override quickFilterValue if user has typed something in QuickFilter
    const dynamicQuickFilterValue = gridState?.quickFilterValue?.value
    if (dynamicQuickFilterValue) request.quickFilterValue = dynamicQuickFilterValue

    try {
      const response = await minimumLoadingTime(() => httpRequest({
        url,
        method,
        data: request,
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
      }))

      if (!response || typeof response !== 'object') throw new Error('Invalid server response format')

      const rowData = response.rows || response.rowData || []
      const rowCount = response.rowCount || rowData.length
      const nextSearchAfter = response.searchAfter

      if (params.api) {
        params.api.dispatchEvent({ type: 'success' })

        if (rowData.length) params.api.hideOverlay()
        else params.api.showNoRowsOverlay()
        if (nextSearchAfter) {
          const gridContext = params.context || params.api.getGridOption('context')
          params.api.setGridOption('context', {
            ...gridContext,
            searchAfter: nextSearchAfter,
          })
        }
      }

      params.success({
        rowData,
        rowCount,
      })
    } catch (error) {
      console.error('[Datagrid] Server-Side getRows Error:', error)
      if (params.api) {
        params.api.dispatchEvent({ type: 'fail' })
      }
      params.fail()
    }
  }

  return { serverSideDatasource: { getRows } }
}

